import { useState, useEffect } from 'react'

export const useMediaInfoFactory = () => {
  const [mediaInfoFactory, setMediaInfoFactory] = useState(null)

  useEffect(() => {
    const resolveFactory = async factoryOrPromise => {
      try {
        // This will work for both direct functions and Promises
        const resolvedFactory = await factoryOrPromise
        setMediaInfoFactory(() => resolvedFactory)
      } catch (err) {
        console.error('Error resolving MediaInfo factory:', err)
      }
    }

    // Check if MediaInfo is already available
    if (window?.MediaInfo?.mediaInfoFactory) {
      resolveFactory(window.MediaInfo.mediaInfoFactory)
      return
    }

    // Set up polling to check for MediaInfo
    const checkInterval = setInterval(() => {
      if (window?.MediaInfo?.mediaInfoFactory) {
        clearInterval(checkInterval)
        resolveFactory(window.MediaInfo.mediaInfoFactory)
      }
    }, 500)

    return () => clearInterval(checkInterval)
  }, [])

  return mediaInfoFactory
}
